import { render, staticRenderFns } from "./OtherOfficeReplyMessage.vue?vue&type=template&id=92a1b92e&scoped=true&lang=pug"
import script from "./OtherOfficeReplyMessage.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeReplyMessage.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeReplyMessage.vue?vue&type=style&index=0&id=92a1b92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a1b92e",
  null
  
)

export default component.exports